import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaEdit, FaPlus, FaTimes, FaTrash, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer';

const ExpandedDescCell = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (!text) return <span>-</span>;
    const shouldTruncate = text.length > 100;


    return (
        <div className="text-left py-1">
            <div className={!isExpanded && shouldTruncate ? "line-clamp-2 overflow-hidden" : "whitespace-pre-wrap break-words"}>
                {text}
            </div>
            {shouldTruncate && (
                <button 
                    type="button"
                    onClick={() => setIsExpanded(!isExpanded)} 
                    className="text-blue-600 text-[10px] font-bold mt-1 hover:underline bg-transparent border-none cursor-pointer transition-all duration-300 ease-in-out"
                >
                    {isExpanded ? '...read less' : '...read more'}
                </button>
            )}
        </div>
    );
};

const AddFeedbackVideos = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedFeedbackId, setSelectedFeedbackId] = useState(null);
    const [tableKey, setTableKey] = useState(0); 
    const [searchQuery, setSearchQuery] = useState('');
    const isMobile = window.innerWidth < 768;

    const [list, setList] = useState([]);
    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);
    const [loadingCards, setLoadingCards] = useState(false);
        
    const [formData, setFormData] = useState({
        feedbacktitle: '',
        feedbackdesc: '',
        feedbacklink: ''
    });
    const loadFeedbackRecords = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "admin/get-all-feedbacks/",
                {
                    params: {
                        page,
                        search,
                        type: "All"
                    }
                }
            );

            setList(res.data.results || []);
            setMobileTotalPages(
                Math.ceil((res.data.count || 0) / 10)
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };
    useEffect(() => {

    if (!isMobile) return;

    loadFeedbackRecords(1, searchQuery);

}, []);

useEffect(() => {

    if (!isMobile) return;

    const timer = setTimeout(() => {

        setMobilePage(1);

        loadFeedbackRecords(1, searchQuery);

    }, 400);

    return () => clearTimeout(timer);

}, [searchQuery]);

useEffect(() => {

    if (!isMobile) return;

    loadFeedbackRecords(mobilePage, searchQuery);

}, [mobilePage]);

    const refreshTableData = () => {
        setTableKey(prev => prev + 1);
    };

    const handleAddNewTrigger = () => {
        setFormData({ feedbacktitle: '', feedbackdesc: '', feedbacklink: '' });
        setIsEditMode(false);
        setIsModalOpen(true);
    };

    const handleEditTrigger = (item) => {
        setFormData({
            feedbacktitle: item.feedbacktitle || '',
            feedbackdesc: item.feedbackdesc || '',
            feedbacklink: item.feedbacklink || ''
        });
        setSelectedFeedbackId(item.feedbackid);
        setIsEditMode(true);
        setIsModalOpen(true);
    };

    const handleStatusToggleTrigger = async (item, refreshTable) => {
        try {
            const res = await API.post(`admin/toggle-feedback-status/${item.feedbackid}/`);
            if (res.data.status === "Success") {
                toast.success(res.data.message);
                refreshTableData(); 
            }
        } catch (err) {
            toast.error("Status update failed!");
        }
    };

    const handleRecordDeleteTrigger = async (pk) => {
        if (!window.confirm("Are you sure you want to delete this feedback?")) return;
        try {
            await API.delete(`admin/delete-feedback/${pk}/`);
            toast.success("Deleted successfully");
            refreshTableData();
        } catch (err) {
            toast.error("Failure processing delete");
        }
    };

    const handleFormSubmitAction = async (e) => {
        e.preventDefault();
        const payload = new FormData();
        payload.append('feedbacktitle', formData.feedbacktitle);
        payload.append('feedbackdesc', formData.feedbackdesc);
        payload.append('feedbacklink', formData.feedbacklink);
        if (isEditMode && selectedFeedbackId) payload.append('feedbackid', selectedFeedbackId);

        try {
            const res = await API.post('admin/get-all-feedbacks/', payload);
            if (res.data.status === "Success") {
                toast.success(isEditMode ? "Updated successfully" : "Added successfully");
                setIsModalOpen(false);
                refreshTableData();
            }
        } catch (err) {
            toast.error("Action failed");
        }
    };

    const gridHeaders = ['Feedback Title', 'Feedback Description', 'Feedback Link', 'Status', 'Action'];

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            <div className="w-full max-w-8xl mx-auto flex flex-col space-y-4 px-2">
                <div className="w-full text-center rounded-lg">
                    <h2 className="text-center text-4xl font-light text-gray-700 mb-8 tracking-tight">Feedback Videos</h2>
                </div>

                <div className="w-full px-1 py-2.5 flex justify-end">
                    <button type="button" onClick={handleAddNewTrigger} className="bg-[#032167] text-white px-5 py-2 rounded text-xs font-semibold flex items-center gap-2 hover:bg-blue-950">
                        <FaPlus size={10} /> Add New
                    </button>
                </div>
                <div className="hidden md:block">
                <TableContainer
                    key={tableKey}
                    columns={gridHeaders}
                    apiUrl="admin/get-all-feedbacks/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    renderRow={(item, index, srNo, formatCurrency, formatDollar, refreshTable) => (
                        <tr key={item.feedbackid || index} className="border-b border-gray-200 hover:bg-gray-50 text-xs bg-white">
                            <td className="p-3 border-r text-center">{srNo}</td>
                            <td className="p-3 border-r text-left pl-5">{item.feedbacktitle || 'N/A'}</td>
                            <td className="p-3 border-r text-left pl-5"><ExpandedDescCell text={item.feedbackdesc} /></td>
                            <td className="p-3 border-r text-blue-600 underline"><a href={item.feedbacklink} target="_blank" rel="noopener noreferrer">{item.feedbacklink || 'N/A'}</a></td>
                            <td className="p-3 border-r text-center">
                                <button type="button" onClick={() => handleStatusToggleTrigger(item, refreshTable)}>
                                    {item.status === 'A' ? <FaCheckCircle size={20} className="text-[#32b392]" /> : <FaTimesCircle size={20} className="text-red-400" />}
                                </button>
                            </td>
                            <td className="p-3 text-center">
                                <button onClick={() => handleEditTrigger(item)} className="text-green-700 mr-3"><FaEdit size={16} /></button>
                                <button onClick={() => handleRecordDeleteTrigger(item.feedbackid)} className="text-red-400"><FaTrash size={16} /></button>
                            </td>
                        </tr>
                    )}
                />
                </div>
                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
                placeholder="Search feedback..."
                className="w-full border rounded-lg p-3 text-sm"
                />

                </div>
                <div className="md:hidden space-y-4 mt-4">

                {
                loadingCards ?

                <div className="text-center py-8">
                Loading...
                </div>

                :

                list.map(item=>(

                <div
                key={item.feedbackid}
                className="
                bg-white
                rounded-xl
                border
                shadow-sm
                p-4
                w-full
                overflow-hidden
                "
                >

                <div className="space-y-3">

                <div>

                <p className="text-xs text-gray-500">
                Feedback Title
                </p>

                <p className="font-bold break-words">
                {item.feedbacktitle}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Description
                </p>

                <ExpandedDescCell
                text={item.feedbackdesc}
                />

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Video Link
                </p>

                <a
                href={item.feedbacklink}
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 break-all underline"
                >

                {item.feedbacklink}

                </a>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Status
                </p>

                {
                item.status==="A"

                ?

                <span className="text-green-600 font-bold">
                Active
                </span>

                :

                <span className="text-red-600 font-bold">
                Inactive
                </span>

                }

                </div>

                <div className="flex justify-end gap-5 pt-2">

                <button
                type="button"
                onClick={()=>handleEditTrigger(item)}
                className="text-green-700"
                >

                <FaEdit size={18}/>

                </button>

                <button
                type="button"
                onClick={()=>handleStatusToggleTrigger(item)}
                >

                {
                item.status==="A"

                ?

                <FaCheckCircle className="text-green-600"/>

                :

                <FaTimesCircle className="text-red-500"/>

                }

                </button>

                <button
                type="button"
                onClick={()=>handleRecordDeleteTrigger(item.feedbackid)}
                className="text-red-500"
                >

                <FaTrash size={18}/>

                </button>

                </div>

                </div>

                </div>

                ))

                }

                </div>
                <div className="md:hidden flex justify-between items-center py-5">

                <button
                disabled={mobilePage===1}
                onClick={()=>setMobilePage(p=>p-1)}
                className="px-4 py-2 border rounded"
                >

                Previous

                </button>

                <span>

                Page {mobilePage} of {mobileTotalPages}

                </span>

                <button
                disabled={mobilePage===mobileTotalPages}
                onClick={()=>setMobilePage(p=>p+1)}
                className="px-4 py-2 border rounded"
                >

                Next

                </button>

                </div>
            </div>

            {isModalOpen && (
                <div
                className="
                fixed
                inset-0
                z-[6000]
                bg-black/60
                flex
                items-start
                md:items-center
                justify-center
                overflow-y-auto
                p-3
                "
                >
                    <div
                    className="
                    bg-white
                    w-full
                    max-w-lg
                    rounded-xl
                    shadow-xl
                    max-h-[90vh]
                    overflow-y-auto
                    p-5
                    "
                    >
                        <h3 className="font-bold mb-4">{isEditMode ? 'Edit Feedback' : 'Add Feedback'}</h3>
                        <form onSubmit={handleFormSubmitAction} className="space-y-4">
                            <input className="w-full p-2 border" placeholder="Title" value={formData.feedbacktitle} onChange={(e) => setFormData({...formData, feedbacktitle: e.target.value})} required />
                            <textarea className="w-full p-2 border" placeholder="Description" value={formData.feedbackdesc} onChange={(e) => setFormData({...formData, feedbackdesc: e.target.value})} required />
                            <input className="w-full p-2 border" placeholder="Link" value={formData.feedbacklink} onChange={(e) => setFormData({...formData, feedbacklink: e.target.value})} required />
                            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4">
                                <button type="button" onClick={() => setIsModalOpen(false)} className="w-full sm:w-auto px-5 py-2 bg-gray-200 rounded">Cancel</button>
                                <button type="submit" className="w-full sm:w-auto px-5 py-2 bg-[#032167] text-white rounded">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddFeedbackVideos;